import { action, makeAutoObservable, observable } from 'mobx';
import { IDialogStore } from './types';
import * as ViewModel from '@/core/presenter/viewModel';
import SeqCalculator from '@/utils/SeqCalculator';

export default class DialogStore implements IDialogStore {
  @observable _popups: ViewModel.IPopupData[] = [];
  _seqCalculator = new SeqCalculator();

  constructor() {
    makeAutoObservable(this);
  }

  public get popups(): ViewModel.IPopupData[] {
    return this._popups;
  }

  @action
  public pushPopup(component: JSX.Element): number {
    const seq = this._seqCalculator.getNextSeq();
    this._popups = [];
    this._popups.push({
      seq,
      element: component,
    });

    return seq;
  }

  @action
  public hidePopup(seq?: number): void {
    if (seq) {
      const idx = this._popups.findIndex((item) => item.seq === seq);
      if (idx !== -1) this._popups.splice(idx, 1);
    } else {
      this._popups.pop();
    }
  }
}
